export default {
	labels: {
		general: {
			phone: "Téléphone",
			fall_detection: "Détection de chute",
			timeout_sos_state: "Timeout SOS State",
			timeout_turn_off_screen: "Timeout Turn Off Screen",
			offline_timer: "Minuterie hors ligne",
			staff: "Personnelle",
			invitations: "Invitations",
			send_invitation: "Envoyer une invitation",
			send: "Envoyer",
			resend: "Renvoyer",
			created: "Créé",
			no_results: "Aucun résultat trouvé",
			organization: "Organisation",
			email: "Email",
			url: "URL",
			billing_email: "Email de facturation",
			use_policy: "Politique d'utilisation",
			privacy_policy: "Politique de confidentialité",
			terms_of_use: "Conditions d'utilisation",
			rent_watches: "Louer montres",
			seats: "Sièges",
			paid: "Payé",
			yearly: "Annuel",
			monthly: "Mensuel",
			daily: "Tous les jours",
			select: "Sélectionner",
			payment_frequency: "Fréquence de paiement",
			subscribe: "Souscrire",
			service: "Service",
			price_by_unit: "Prix à l'unité",
			units: "Unités",
			total: "Total",
			payment: "Paiement",
			next_payment: "Prochain paiement",
			auto_renew: "Renouvellement automatique",
			empty: "Vide",
			view: "Voir",
			subscription: "Abonnement",
			add_subscription: "Ajouter un abonnement",
			transactions: "Transactions",
			transaction: "Transaction",
			service_period: "Période de service",
			subtotal: "Subtotal",
			tax: "Tax",
			account_movement: "Mouvement de compte",
			logs: "Logs",
			message: "Message",
			amount: "Montant",
			operation: "Opération",
			slots: "Slots",
			in_use: "En usage",
			available: "Disponible",
			add_payment_method: "Ajouter un moyen de paiement",
			current: "Actuel",
			active: "Actif",
			set_active: "Activer",
			account: "Compte",
			account_personal: "Compte personnel",
			my_idicare: "Mon IDICARE",
			timezone: "Fuseau horaire",
			subscriptions: "Abonnements",
			budget: "Budget",
			resume: "Résumé",
			account_movements: "Mouvements de compte",
			payment_methods: "Méthodes de payement",
			birthdate: "Date de naissance",
			birthday: "Anniversaire",
			blood_type: "Groupe sanguin",
			color: "Couleur",
			comments: "Commentaires",
			contact: "Contact",
			date: "Date",
			description: "Description",
			device_type: "Type d'appareil",
			device: "Dispositif",
			disease: "Maladie",
			dose: "Dose",
			end_date: "Date de fin",
			end: "Fin",
			events: "Événements",
			expire_date: "Date d'expiration",
			feel: "Sentiment",
			first: "Premier",
			gender: "Genre",
			height: "Hauteur",
			hour: "Heure",
			imei: "IMEI",
			in_use: "Utilisé",
			insurance: "Assurance",
			last_sync: "Last sync",
			last: "Dernier",
			location: "Emplacement",
			max: "Max",
			min: "Min",
			max_start: "Systolique début",
			max_end: "Systolique fin",
			min_start: "Diastolique début",
			min_end: "Diastolique fin",
			name: "Nom",
			number: "Nombre",
			options: "Options",
			picture: "Image",
			position: "Position",
			previous: "Précédent",
			relation_contact: "Contact relation",
			relation: "Relation",
			shape: "Forme",
			start_date: "Date de début",
			start: "Début",
			state: "Etat",
			status: "Statut",
			today: "Aujourd'hui",
			type: "Type",
			uptime: "Uptime",
			value: "Valeur",
			week: "Semaine",
			weight: "Poids",
			years_old: "Ans",
			urgency: "Urgence",
			person: "Personne",
			report: "Rapport",
			day: "Journée",
			month: "Mois",
			year: "Année",
			minute: "Minute",
			sos_phone: "Téléphone SOS",
			sync_interval_normal: "Intervalle de synchronisation en état normal",
			sync_interval_alert: "Intervalle de synchronisation en état d'alerte",
			ok: "OK",
			sos: "SOS",
			false_positive: "Faux positif",
			no_response: "Pas de réponse",
			average: "Moyenne",
			standard_deviation: "Déviation standard",
			samples: "Des échantillons",
			systolic: "Systolique",
			diastolic: "Diastolique",
			fall: "Tombe",
			responded: "A répondu",
			not_responded: "Pas répondu",
			no_reports: "Aucun rapport",
			no_notifications: "Aucune notification",
			subject: "Assujettir",
			last_activity: "Dernière Activité",
			responsible: "Responsable",
			category: "Catégorie",
			search_location: "Recherchez emplacement",
			steps: "pas",
			fall_detected: "Chute détectée",
			address: "Adresse",
			no: "Non",
			yes: "Oui",
			falling: "Chute",
			geofencing: "Geofencing",
			unresponded: "Sans réponse",
			in_progress: "En cours",
			done: "Terminé",
			cancelled: "Annulé",
			cancel: "Annuler",
			open: "Ouvert",
			closed: "Fermé",
			see: "Voir",
			file: "Fichier",
			take_later: "Prendre plus tard",
			take: "Prendre",
			skip: "Sauter",
			miss: "Manqué",
			better: "Meilleur",
			same: "Même",
			worse: "Pire",
		},
		auth: {
			fullname: "Nom complet",
			email: "Email",
			password: "Mot de passe",
			confirm_password: "Confirmez le mot de passe",
		},
		profile: {
			new_name: "Nouveau nom",
			new_email: "Nouvel email",
			old_password: "Ancien mot de passe",
			new_password: "Nouveau mot de passe",
			confirm_new_password: "Confirmer le nouveau mot de passe",
			personal_information: "Informations personnelles",
			contacts: "Contacts",
			medical_information: "Information médicale",
			family_information: "Information familiale",
			other_information: "Autres informations",
			social_numbers: "Numéros sociaux",
			insurances: "Assurances",
		},
		alerts: {
			alert_value: "Valeur de {value} {units} de l'utilisateur {userName}",
			alert_value_falls: "{value} de l'utilisateur {userName}",
			alert_value_remove_title: "Horloge supprimée",
			alert_value_remove: "Patient(e) {userName} à retiré l'horloge de son poignet",
		},
		week: {
			mon: "Lun",
			tue: "Mar",
			wed: "Mer",
			thu: "Jeu",
			fri: "Ven",
			sat: "Sam",
			sun: "Dim",
		},
		numbers: {
			adse: "ADSE",
			civil_id: "Identité civile,",
			health_number: "Numéro patient",
			social_security: "Numéro de sécurité sociale",
			tax_number: "Numéro d'identification fiscale",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/labels/labels_fr.js